import classNames from "classnames";

export const Separator = ({ className }: { className?: string }) => (
  <div className={classNames(className, "border-t")} />
);
